import {Component, ViewEncapsulation} from "@angular/core";
import {Settings} from "../../services/settings.service";

@Component({
    selector: 'no-results-message',
    templateUrl: './no-results-message.component.html',
    styleUrls: ['./no-results-message.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class NoResultsMessageComponent {

    constructor(public settings: Settings) {}
}



// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/core/ui/no-results-message/no-results-message.component.ts